// Home
export const HOME_PATH = '/'

// Root paths
export const APPLICATION_MANAGER_NAME = 'application-manager'
export const EXPENSE_REQUESTS_NAME = 'admin-expense-requests'
export const CENSUS_MANAGEMENT = 'census-management'
export const MESSAGE_MANAGEMENT = 'message-management'
export const PROFILE = 'profile'
export const LIFE_EVENTS = 'qle_v1'
export const CENSORY = 'censory'
export const PROSPECTS_V2_NAME = 'prospects-v2'
export const QUOTING_V2_NAME = 'quoting-v2'
export const PROSPECTS_V3_NAME = 'prospects-v3'
export const QUOTING_V3_NAME = 'quoting-v3'
export const QLE = 'qle'
export const RECRUITING = 'recruiting'
export const DOCUMENT_CENTER = 'document-center'
